import { Map } from 'immutable';

import { DELETE_CAMERA, RECEIVE_CAMERAS, REQUEST_CAMERA } from '@sophocles/entities/Camera/cameraActions';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_CAMERAS: // Read
      return state.merge(action.cameras);
    case DELETE_CAMERA: // Socket delete
      return state.delete(action.camera.toString());
    case REQUEST_CAMERA:
    default:
      return state;
  }
}

export function cameraReducer(state = Map(), action) {
  switch (action.type) {
    case RECEIVE_CAMERAS:
    case DELETE_CAMERA:
    case REQUEST_CAMERA:
      return getState(state, action);
    default:
      return state;
  }
}
